import { render, staticRenderFns } from "./SuccessPage.vue?vue&type=template&id=b8139360&scoped=true"
import script from "./SuccessPage.vue?vue&type=script&lang=js"
export * from "./SuccessPage.vue?vue&type=script&lang=js"
import style0 from "./SuccessPage.vue?vue&type=style&index=0&id=b8139360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8139360",
  null
  
)

export default component.exports